import { Trans, useTranslation } from "react-i18next";
import benefitHero3 from "~/assets/images/microsite/benefit_hero_left_addition.jpeg";

export function AblaufComponent({ type = "pharmacy" }: { type?: "pharmacy" | "customer" }) {
  const { t } = useTranslation();
  const stepsPharmacy = [
    {
      title: t("Besuchen Sie Ihre Apotheke und fragen Sie nach CaboCheck."),
      description: t(
        "Bei jedem Test erhalten Sie ein Infoblatt mit Ihrem persönlichen Test QR-Code (CaboCheck-ID), über den Sie das Testergebnis abrufen können.",
      ),
    },
    {
      title: t("Testdurchführung vor Ort oder zu einem späteren Zeitpunkt"),
      description: (
        <Trans
          i18nKey={
            "Vorbeikommen und in den Finger pieksen lassen. Wir nehmen Ihnen Blut aus der Fingerkuppe und schicken Ihre Blutprobe an ein medizinisches Facharztlabor bei CaboLab bzw. werten sie direkt bei uns vor Ort bei CaboPoc aus. <strong>Trinken Sie vorher ausreichend Wasser (300ml).</strong>"
          }
        />
      ),
    },
    {
      title: t("Schnelle und zuverlässige Ergebnisse"),
      description: t(
        "Sie erhalten nach wenigen Minuten (CaboPoc) bzw. wenigen Tagen (CaboLab) eine Mail und können Ihre Ergebnisse bei uns abholen und besprechen oder selbst online abrufen. Die Ergebnisse werden mit einer Ampel dargestellt. Wenn die Ampel bei Ihnen auf Rot oder Gelb steht, können Sie uns – wenn Sie mögen – die Ergebnisse freigeben. Wir schauen uns dann die Ergebnisse an und beraten Sie, was Sie jetzt idealerweise tun sollten.",
      ),
    },
  ];

  const stepsCustomer = [
    {
      title: t("Besuchen Sie Ihre Apotheke und fragen Sie nach CaboCheck."),
      description: t(
        "Bei jedem Test erhalten Sie ein Infoblatt mit Ihrem persönlichen Test QR-Code (CaboCheck-ID), über den Sie das Testergebnis abrufen können.",
      ),
    },
    {
      title: t("Testdurchführung vor Ort oder zu einem späteren Zeitpunkt"),
      description: (
        <Trans
          i18nKey={
            "In Ihre Apotheke gehen und in den Finger pieksen lassen. Ihre Apotheke nimmt Ihnen Blut aus der Fingerkuppe und schickt Ihre Blutprobe an ein medizinisches Facharztlabor bei CaboLab bzw. wertet sie direkt vor Ort bei CaboPoc aus. <strong>Trinken Sie vorher ausreichend Wasser (300ml).</strong>"
          }
        />
      ),
    },
    {
      title: t("Schnelle und zuverlässige Ergebnisse"),
      description: t(
        "Sie erhalten nach wenigen Minuten (CaboPoc) bzw. wenigen Tagen (CaboLab) eine Mail und können Ihre Ergebnisse bei uns abholen und besprechen oder selbst online abrufen. Die Ergebnisse werden mit einer Ampel dargestellt. Wenn die Ampel bei Ihnen auf Rot oder Gelb steht, können Sie - wenn Sie mögen – die Ergebnisse für Ihre Apotheke freigeben. Ihre Apotheke schaut sich dann mit Ihnen die Ergebnisse an und berät Sie, was Sie idealerweise tun sollten.",
      ),
    },
  ];

  const steps = type === "pharmacy" ? stepsPharmacy : stepsCustomer;

  return (
    <div className="public-container py-8">
      <div className="flex flex-col md:flex-row">
        <div className="mb-8 pr-0 md:mb-0 md:w-1/2 md:pr-8">
          <h1 className="mb-4 text-3xl font-bold sm:text-4xl">{t("Ablauf")}</h1>
          <p className="text-gray-600">
            {t(
              "Die Blutabnahme ist ein schneller und nahezu schmerzfreier Prozess, bei dem eine kleine Menge Blut zur Analyse entnommen wird.",
            )}
          </p>
          <div className="mt-6 overflow-hidden rounded-3xl bg-gray-100">
            <img src={benefitHero3} alt="" className="h-full w-full object-cover" />
          </div>
        </div>
        <div className="md:w-1/2">
          {steps.map((step, index) => (
            <div key={index} className="mb-4 grid gap-2 rounded-2xl bg-gray-100 p-4 sm:p-6">
              <div className="relative flex h-12 w-12 items-center justify-center rounded-full text-2xl font-bold text-blue-550">
                <div className="absolute inset-0 rounded-full bg-dynamic-primary opacity-20" />
                <span className="z-10 text-dynamic-primary">{index + 1}</span>
              </div>
              <h2 className="mb-2 text-xl font-bold sm:text-2xl">{step.title}</h2>
              <p className="text-gray-500">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
